export class Environment{
    public static apiUrl = process.env.NODE_ENV === 'development' ?
        "https://localhost:9447/Api/" :
        process.env.REACT_APP_BACKEND_URL as string;


    public static representativePageUrl = process.env.NODE_ENV === 'development' ?
    "https://localhost:3001/" :
    process.env.REACT_APP_INFO_URL as string;    

    public static OPENA_FORM_PRD_URL = "app.opena";
    public static phoneNumberPrefix = "+48 ";
    public static grantType = "otp_credentials";
    public static clientId = "otp.web";
    public static clientSecret = "otp.web";
    public static scope = "openid"

    //Flexi config
    public static phoneNumber = "58 73 900 99";  
    public static isPhoneNumberAvaliable = true;  
    public static desktopBreakpoint = 1000 // Szerokość ekranu od której przyjmujemy że urządzenie to desktop

    public static formSubmitionButtonId = 'form-submit-button'
}